/**
 * Spacing scale — canonical 4-based step scale. Pure value (no React/RN imports).
 *
 * Accessed only via useSpacing() / theme.spacing; keys are scale-local, so
 * spacing.xl (20) intentionally differs from radius.xl (24).
 */
export const SPACING = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  '2xl': 24,
  '3xl': 32,
  '4xl': 40,
  '5xl': 48,
  '6xl': 64,
} as const;
